import type { RouteRecordRaw } from "vue-router";

export const faqRoutes: RouteRecordRaw[] = [
  {
    path: "/faq/:section/:item",
    name: "faq-item",
    component: () => import(/* webpackChunkName: "dashboard-faq" */ "../../components/faq/FaqView.vue"),
    meta: { titleKey: "pageTitle.faq", scrollGroup: "faq", viewGroup: "faq" }
  },
  {
    path: "/faq/:section",
    name: "faq-section",
    component: () => import(/* webpackChunkName: "dashboard-faq" */ "../../components/faq/FaqView.vue"),
    meta: { titleKey: "pageTitle.faq", scrollGroup: "faq", viewGroup: "faq" }
  },
  {
    path: "/faq",
    name: "faq",
    component: () => import(/* webpackChunkName: "dashboard-faq" */ "../../components/faq/FaqView.vue"),
    meta: { titleKey: "pageTitle.faq", scrollGroup: "faq", viewGroup: "faq" }
  },
  {
    path: "/customer-service",
    name: "customer-service",
    component: () =>
      import(/* webpackChunkName: "dashboard-customer-service" */ "../../components/faq/FaqContactPageView.vue"),
    meta: { titleKey: "pageTitle.customerService", viewGroup: "customer-service" }
  },
  {
    path: "/tour",
    name: "tour",
    component: () => import(/* webpackChunkName: "dashboard-tour" */ "../../components/tour/TourView.vue"),
    meta: { titleKey: "pageTitle.tour", viewGroup: "tour" }
  }
];
